import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { CategoryConsumer } from '../../../../CategoryContext'
import PageTitle from '../../PageTitle/PageTitle'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import CategoryForm from './CategoryForm'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'

const CategoryEditContent = ({ pageTitle }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Categories'/>,
          link: NamedRoutes.subscription.category.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Categories.List.AddCategory.Title'/>}/>
      <PageTitle title={pageTitle ?? <FormattedMessage id='Categories.List.AddCategory.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <CategoryConsumer>
              {({ categoryDataLoading, categoryDataFailure, categoryData, handleCategorySubmit, pageAction }) => (
                <>
                  {!!categoryDataLoading && <FormLoader loading={true}/>}
                  {!!categoryDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
                  }
                  {pageAction === 'add' ?
                    <CategoryForm currentDate={{}} onSubmit={handleCategorySubmit}/> :
                    (!!categoryData && !!Object.keys(categoryData).length &&
                      <CategoryForm currentDate={categoryData} onSubmit={handleCategorySubmit}/>)
                  }
                </>
              )}
            </CategoryConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default CategoryEditContent
